import React from 'react';

const ArtistModal = ({
  id,
  name,
  setName,
  website,
  setWebsite,
  facebook,
  setFacebook,
  twitter,
  setTwitter,
  instagram,
  setInstagram,
  youtube,
  setYoutube,
  spotify,
  setSpotify,
  apple,
  setApple,
  deezer,
  setDeezer,
  soundCloud,
  setSoundCloud,
  isAddingArtist,
  handleAddArtist,
  extraAction = null,
  closeTarget = null
}) => {
  return (
    <div className="modal fade" id={id} tabIndex="-1" aria-labelledby={`${id}Label`} aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id={`${id}Label`}>Add Artist</h1>
            <button 
              type="button" 
              className="btn-close" 
              data-bs-dismiss="modal"
              data-bs-toggle={closeTarget ? "modal" : ""}
              data-bs-target={closeTarget ? closeTarget : ""}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-12">
                <h4 className='dash-form-heading'>General Information</h4>
              </div>
              <div className="col-md-6 mt-3">
                <div className="dash-form-group">
                  <label>Name</label>
                  <input value={name} onChange={(e) => setName(e.target.value)} type="text" placeholder='Name' className='dash-form-input' />
                </div>
              </div>
              <div className="col-md-6 mt-3">
                <div className="dash-form-group">
                  <label>Website</label>
                  <input value={website} onChange={(e) => setWebsite(e.target.value)} type="text" placeholder='Website' className='dash-form-input' />
                </div>
              </div>
              <div className="col-12 mt-4">
                <h4 className='dash-form-heading'>Profile Information</h4>
              </div>
              <div className="col-md-6 mt-3">
                <div className="dash-form-group">
                  <label>Spotify</label>
                  <input value={spotify} onChange={(e) => setSpotify(e.target.value)} type="text" placeholder='Spotify' className='dash-form-input' />
                </div>
              </div>
              <div className="col-md-6 mt-3">
                <div className="dash-form-group">
                  <label>Apple Music</label>
                  <input value={apple} onChange={(e) => setApple(e.target.value)} type="text" placeholder='Apple' className='dash-form-input' />
                </div>
              </div>
              <div className="col-md-6 mt-3">
                <div className="dash-form-group">
                  <label>Facebook</label>
                  <input value={facebook} onChange={(e) => setFacebook(e.target.value)} type="text" placeholder='Facebook' className='dash-form-input' />
                </div>
              </div>
              <div className="col-md-6 mt-3">
                <div className="dash-form-group">
                  <label>Instagram</label>
                  <input value={instagram} onChange={(e) => setInstagram(e.target.value)} type="text" placeholder='Instagram' className='dash-form-input' />
                </div>
              </div>
              <div className="col-md-6 mt-3">
                <div className="dash-form-group">
                  <label>Youtube</label>
                  <input value={youtube} onChange={(e) => setYoutube(e.target.value)} type="text" placeholder='Youtube' className='dash-form-input' />
                </div>
              </div>
              <div className="col-md-6 mt-3">
                <div className="dash-form-group">
                  <label>X</label>
                  <input value={twitter} onChange={(e) => setTwitter(e.target.value)} type="text" placeholder='Twitter' className='dash-form-input' />
                </div>
              </div>
              <div className="col-md-6 mt-3">
                <div className="dash-form-group">
                  <label>Deezer</label>
                  <input value={deezer} onChange={(e) => setDeezer(e.target.value)} type="text" placeholder='Deezer' className='dash-form-input' />
                </div>
              </div>
              <div className="col-md-6 mt-3">
                <div className="dash-form-group">
                  <label>SoundCloud</label>
                  <input value={soundCloud} onChange={(e) => setSoundCloud(e.target.value)} type="text" placeholder='SoundCloud' className='dash-form-input' />
                </div>
              </div>
              <div className="col-12 mt-3">
                <div className="dash-form-btns">
                  <button 
                    className='dash-form-btn' 
                    data-bs-dismiss="modal"
                    disabled={isAddingArtist}
                    onClick={() => {
                      handleAddArtist();
                      if (extraAction) extraAction();
                    }}
                  >
                    {isAddingArtist ? 'Submitting...' : 'Submit'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArtistModal; 